import React from "react";
import { useTheme } from "../../theme";
import SectionLabel from "../shared/SectionLabel";

const sections = [
  {
    title: "What is a Tag?",
    body: "A Tag is a record filed by someone who's looking for an old online friend. It contains the username, the platform, and a short personal note. A memory, a year, a game. Nothing identifying, nothing invasive.",
  },
  {
    title: "What can I include?",
    body: "Describe your relationship with the person: how you met, what games you played, what you remember. Don't include real names, addresses, phone numbers, or any information that could personally identify someone.",
  },
  {
    title: "What happens when I file a Tag?",
    body: "Your Tag gets indexed. When the person searches their old username, your note surfaces. They decide whether to respond. We never message, email, or contact anyone on your behalf.",
  },
  {
    title: "Can I remove a Tag?",
    body: "Yes. If you filed a Tag, you can delete it at any time. If someone filed a Tag for you and you'd like it removed, click 'remove'. No login required, no questions asked.",
  },
  {
    title: "Platform support",
    body: "We currently support Steam, PlayStation Network, Xbox Live, and Discord. More platforms may be added in the future based on community feedback.",
  },
];

const GuideLines = () => {
  const { p, d, fonts } = useTheme();

  return (
    <div style={{ minHeight: '100%', background: p.bg, color: p.text, fontFamily: fonts.sans }}>
      {/* hero */}
      <section style={{
        padding: `${d.hero}px ${d.pad}px`, borderBottom: `1px solid ${p.border}`,
        background: p.bgPanel,
      }}>
        <div style={{ maxWidth: 780, margin: '0 auto', textAlign: 'center' }}>
          <SectionLabel style={{ justifyContent: 'center' }}>§ guidelines</SectionLabel>
          <h1 style={{
            fontFamily: fonts.serif, fontSize: 56, fontWeight: 400,
            letterSpacing: '-.025em', lineHeight: 1.04, color: p.textHi, margin: '0 0 20px',
          }}>
            UserTags Guidelines
          </h1>
          <p style={{
            fontSize: d.body, color: p.text, lineHeight: 1.6,
            maxWidth: 600, margin: '0 auto',
          }}>
            Reconnecting old friends is our objective. We want to help you understand our guidelines so you can have the best experience with us.
          </p>
        </div>
      </section>

      {/* content */}
      <section style={{ padding: `${d.hero * 0.7}px ${d.pad}px` }}>
        <div style={{ maxWidth: 780, margin: '0 auto' }}>
          {sections.map((s, i) => (
            <div key={i} style={{
              padding: `${d.gap}px 0`,
              borderBottom: i < sections.length - 1 ? `1px solid ${p.border}` : 'none',
            }}>
              <div style={{
                fontFamily: fonts.mono, fontSize: 11, color: p.accent,
                letterSpacing: '.08em', marginBottom: 12,
              }}>
                {String(i + 1).padStart(2, '0')}
              </div>
              <h3 style={{
                fontFamily: fonts.serif, fontSize: 24, fontWeight: 500,
                color: p.textHi, letterSpacing: '-.01em', margin: '0 0 10px',
              }}>
                {s.title}
              </h3>
              <p style={{
                fontSize: 15, lineHeight: 1.6, color: p.text, margin: 0,
              }}>
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default GuideLines;
